export class OfficeError extends Error {
  constructor(
    public readonly code: number,
    message: string
  ) {
    super(message);
    this.code = code;
    this.name = "OfficeError";
    Object.setPrototypeOf(this, OfficeError.prototype);
  }
}
